import createWasteGroupingEnvironmentPermitDetailPage from './CreateUpdate';
import createWasteGroupingEnvironmentPermitPageFactory from './index';
import { wasteGroupingEnvironmentPermitRoutes } from './routes';

export const createWasteGroupingEnvironmentPermitPages = () => {
  const WasteGroupingEnvironmentPermit = createWasteGroupingEnvironmentPermitPageFactory();
  const AddWasteGroupingEnvironmentPermit = createWasteGroupingEnvironmentPermitDetailPage();
  const UpdateWasteGroupingEnvironmentPermit = createWasteGroupingEnvironmentPermitDetailPage();
  const WasteGroupingEnvironmentPermitPage = wasteGroupingEnvironmentPermitRoutes;

  return () => (
    <WasteGroupingEnvironmentPermitPage
      WasteGroupingEnvironmentPermit={WasteGroupingEnvironmentPermit}
      AddWasteGroupingEnvironmentPermit={AddWasteGroupingEnvironmentPermit}
      UpdateWasteGroupingEnvironmentPermit={UpdateWasteGroupingEnvironmentPermit}
    />
  );
};

